<template>
  <div class="input-icon-wrapper">
    <i class="fa fa-calendar calendar-icon"></i>
    <flat-pickr
      v-model="internalValue"
      :config="mergedConfig"
      class="form-control with-icon"
      :placeholder="placeholder"
    />
  </div>
</template>

<script setup>
import FlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { defineProps, defineEmits, computed, onBeforeUnmount } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number, Date, Array, null],
    default: null
  },
  placeholder: {
    type: String,
    default: 'select'
  },
  config: {
    type: Object,
    default: () => ({})
  }
})

const defaultConfig = {
  dateFormat: 'Y-m-d',
  mode: 'single',
  allowInput: true,
  disableMobile: true
}

const emit = defineEmits(['update:modelValue'])

const internalValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})

// เก็บ instance ของ flatpickr เพื่อปรับตำแหน่ง
let fpInstance = null

const mergedConfig = computed(() => {
  const config = {
    ...defaultConfig,
    ...props.config,
    onOpen: [
      function (_, __, instance) {
        fpInstance = instance
        adjustCalendarPosition()
        window.addEventListener('scroll', adjustCalendarPosition, true)
        window.addEventListener('resize', adjustCalendarPosition)
      }
    ],
    onDayCreate: [
      function (_, __, ___, dayElem) {
        dayElem.classList.remove('today')
      }
    ]
  }

  if (props.modelValue) {
    config.defaultDate = props.modelValue
  }

  return config
})

function adjustCalendarPosition() {
  if (!fpInstance || !fpInstance.calendarContainer) return
  requestAnimationFrame(() => {
    const inputRect = fpInstance._input.getBoundingClientRect()
    const rightOffset = 40 // ปรับค่านี้เพื่อเลื่อนขวาเพิ่ม
    fpInstance.calendarContainer.style.position = 'absolute'
    fpInstance.calendarContainer.style.left = inputRect.left + window.scrollX + rightOffset + 'px'
    fpInstance.calendarContainer.style.top = inputRect.bottom + window.scrollY + 'px'
    fpInstance.calendarContainer.style.zIndex = 9999
  })
}


onBeforeUnmount(() => {
  window.removeEventListener('scroll', adjustCalendarPosition, true)
  window.removeEventListener('resize', adjustCalendarPosition)
})
</script>

<style>
.input-icon-wrapper {
  position: relative;
  width: 250px;
}

.calendar-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  pointer-events: none;
  z-index: 2;
  font-size: 16px;
}

.input-icon-wrapper input.with-icon {
  padding-left: 45px !important;
}
</style>
